<template>
    <div>
        <b-row>
            <b-col sm="12" md="12" lg="12" xl="12">
                <b-card no-body>
                    <b-card-header>
                        <span class="h5">
                            <strong>{{ fornecedor.cgcCfo }} - {{ fornecedor.nome }}</strong>
                            <b-badge variant="warning" class="ml-2">{{operacao}}</b-badge>
                        </span>
                    </b-card-header>
                    <b-card-body>
                        <app-erros-box :erros="erros" v-if="erros.length > 0"></app-erros-box>
                        <b-row>
                            <b-col>
                                <b-alert show>
                                    <strong>CND - Certidão Conjunta de Débitos PJ</strong>
                                </b-alert>
                                <cnd :fornecedor="fornecedor"></cnd>
                                <certidoes-logs
                                    :logs="fornecedor.logsCnd"
                                    v-if="$temAcessoView('CERT-02')"
                                ></certidoes-logs>
                            </b-col>
                            <b-col>
                                <b-alert show>
                                    <strong>FGTS - Regularidade do Empregador</strong>
                                </b-alert>
                                <fgts :fornecedor="fornecedor"></fgts>
                                <certidoes-logs
                                    :logs="fornecedor.logsFgts"
                                    v-if="$temAcessoView('CERT-02')"
                                ></certidoes-logs>
                            </b-col>
                        </b-row>
                    </b-card-body>
                    <b-card-footer>
                        <b-button variant="danger" @click.stop="voltar()">
                            <span>
                                <i class="fa fa-history mr-2"></i> Voltar
                            </span>
                        </b-button>
                        <b-button
                            variant="primary"
                            @click.stop="atualizarCertidoes()"
                            v-if="$temAcessoView('CERT-03')"
                            class="ml-1"
                        >
                            <span>
                                <i class="fa fa-refresh mr-2"></i> Atualizar Certidões
                            </span>
                        </b-button>
                    </b-card-footer>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import CertidoesServicos from './../rm/CertidoesServicos'
import Cnd from './Cnd'
import Fgts from './Fgts'
import CertidoesLogs from './CertidoesLogs'

export default {
	components: { Cnd, Fgts, CertidoesLogs },

	data() {
		return {
			fornecedor: {},
			operacao: 'DETALHAR',
			tabIndex: 0,
			erros: []
		}
	},

	methods: {
		voltar() {
			this.$router.push({ name: 'Certidoes' })
		},

		obterFornecedor() {
			this.$store.dispatch('addRequest')
			CertidoesServicos.obterPorFornecedor(
				this.$route.params.codCfo
			).then(response => {
				if (response) {
					if (response.success) {
						this.fornecedor = response.data
					} else {
						this.erros = response.errors
					}
				}
				this.$store.dispatch('removeRequest')
			})
		},

		atualizarCertidoes() {
			this.$store.dispatch('addRequest')
			CertidoesServicos.atualizarCertidoesPorFornecedor(
				this.$route.params.codCfo
			).then(response => {
				if (response) {
					if (response.success) {
						this.fornecedor = response.data
						this.$store.dispatch('setRecarregar', true)
					} else {
						this.erros = response.errors
					}
				}
				this.$store.dispatch('removeRequest')
			})
		}
	},

	computed: {},

	created() {
		this.obterFornecedor()
	}
}
</script>
